// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { Analytics, getAnalytics, isSupported } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "bc-transparent.firebaseapp.com",
  projectId: "bc-transparent",
  storageBucket: "bc-transparent.appspot.com",
  messagingSenderId: "765557561318",
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: "G-2FR2EF018Z",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
let analytics: Analytics | null = null;
isSupported().then((isSupported) => {
  if (isSupported) {
    analytics = getAnalytics();
  } else {
    console.log("Firebase Analytics is not supported in this environment.");
  }
});

export { app, db, auth, analytics };
